import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './LocationsMap.css';

// Fix for default marker icons in React-Leaflet
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import iconRetina from 'leaflet/dist/images/marker-icon-2x.png';

let DefaultIcon = L.icon({
  iconUrl: icon,
  iconRetinaUrl: iconRetina,
  shadowUrl: iconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  tooltipAnchor: [16, -28],
  shadowSize: [41, 41]
});

L.Marker.prototype.options.icon = DefaultIcon;

// Custom icon for headquarters (larger, different color)
const headquartersIcon = L.divIcon({
  className: 'custom-marker headquarters-marker',
  html: '<div class="marker-pin headquarters-pin"></div>',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30]
});

// Custom icon for manufacturing facility
const facilityIcon = L.divIcon({
  className: 'custom-marker facility-marker',
  html: '<div class="marker-pin facility-pin"></div>',
  iconSize: [30, 30],
  iconAnchor: [15, 30],
  popupAnchor: [0, -30]
});

// Custom icon for sales offices
const officeIcon = L.divIcon({
  className: 'custom-marker office-marker',
  html: '<div class="marker-pin office-pin"></div>',
  iconSize: [25, 25],
  iconAnchor: [12, 25],
  popupAnchor: [0, -25]
});

const locations = [
  {
    id: 1,
    name: 'El Paso, TX',
    type: 'headquarters',
    position: [31.7619, -106.4850],
    address: '221 N Kansas St Ste 700',
    city: 'El Paso, Texas 79901-1443',
    description: 'Headquarters - Engineering and Sales Office'
  },
  {
    id: 2,
    name: 'Milwaukee, WI',
    type: 'office',
    position: [43.0389, -87.9065],
    description: 'Remote sales / applications representative'
  },
  {
    id: 3,
    name: 'Toluca, Mexico',
    type: 'office',
    position: [19.2925, -99.6569],
    description: 'Remote sales / applications representative'
  },
  {
    id: 4,
    name: 'Ciudad Juarez, Mexico',
    type: 'facility',
    position: [31.6904, -106.4244],
    description: 'Manufacturing Facility - Shop for building machines from scratch, machining and assembly'
  }
];

const LocationsMap = () => {
  useEffect(() => {
    // Ensure map tiles load correctly
    return () => {
      // Cleanup if needed
    };
  }, []);

  const getIcon = (type) => {
    switch (type) {
      case 'headquarters':
        return headquartersIcon;
      case 'facility':
        return facilityIcon;
      case 'office':
        return officeIcon;
      default:
        return DefaultIcon;
    }
  };

  // Calculate center point (average of all locations)
  const centerLat = locations.reduce((sum, loc) => sum + loc.position[0], 0) / locations.length;
  const centerLng = locations.reduce((sum, loc) => sum + loc.position[1], 0) / locations.length;

  return (
    <div className="locations-map-wrapper">
      <MapContainer
        center={[centerLat, centerLng]}
        zoom={4}
        style={{ height: '500px', width: '100%', borderRadius: '8px' }}
        scrollWheelZoom={true}
        className="locations-map"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {locations.map((location) => (
          <Marker
            key={location.id}
            position={location.position}
            icon={getIcon(location.type)}
          >
            <Popup>
              <div className="map-popup">
                <h4>{location.name}</h4>
                {location.address && <p>{location.address}</p>}
                {location.city && <p>{location.city}</p>}
                <p className="popup-description">{location.description}</p>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default LocationsMap;

